<div id="infinite-scroll-global-container" #infiniteScrollGlobalContainer>
  @if (!isBlog()) {
    <app-header></app-header>
  }
  @if (isBlog()) {
    <app-cms-blog-header></app-cms-blog-header>
  }

  <main><router-outlet></router-outlet></main>

  @if (!isBlog()) {
    <app-footer></app-footer>
  }
  @if (isBlog()) {
    <app-cms-blog-footer></app-cms-blog-footer>
  }
</div>
